import {useState,useEffect} from "react";
import realtimeDB from "../Utils/api";

const useItems = id =>
{
    const [Items, setItems] = useState([]);
    useEffect(() => 
    {
        realtimeDB.ref("/Menu").child("/CategoriasDOS").child(id).child("/Items").on("value",snapshot =>
        {
            let items=[];

            snapshot.forEach(item =>
            {
               items.push({id:item.key,data:item.val()})
            })
            items=items.sort((a,b) => (a.data.index > b.data.index) ? 1 : ((b.data.index > a.data.index) ? -1 : 0))
            setItems(items);
        })
    }, []);
    return Items;
}

const useAllItems=()=>
{
    const [Items, setItems] = useState([]);
    useEffect(() => 
    {
        
        realtimeDB.ref("/Menu/CategoriasDOS").on("value",snapshot =>
        {
            let items =[];
            snapshot.forEach(categorias =>
            {
                categorias.forEach(categoria =>
                {
                   categoria.forEach(item => 
                    {
                        items.push(item.val());
                    })
                })
            });

            setItems(items);
        })
    }, [])
    return Items;
}

export default useItems;
export {useAllItems};